export const blue = 'BLUE'
export const white = 'WHITE'

export const FIGHTERS = {
    BLUE: blue,
    WHITE: white
} 

export const SCORES={
    IPPON: 'IPPON',
    WAZARI: 'WAZARI',
    SHIDO: 'SHIDO'
}


// WEBPACK FOOTER //
// ./src/constants.js